import { Get, getAPIUrl, Post, Put, Delete } from "../../../ApiServices/apiMethod";
import { PlanEndpoints } from "./PlansEndpoint";

// ✅ CREATE
export const createPlan = (data, param = "") => {
  const url = getAPIUrl(PlanEndpoints.createPlan, param);
  return Post(url, data);
};

// ✅ GET ALL
export const getAllPlans = (param = "") => {
  const url = getAPIUrl(PlanEndpoints.getAllPlans, param);
  return Get(url);
};

// ✅ GET DETAILS
export const getPlanDetails = (id, param = "") => {
  const url = getAPIUrl(PlanEndpoints.getPlanDetails + id, param);
  return Get(url);
};

// ✅ UPDATE
export const updatePlan = (id, data, param = "") => {
  const url = getAPIUrl(PlanEndpoints.updatePlan + id, param);
  return Put(url, data);
};

// ✅ DELETE - ADD THIS
export const deletePlan = (id, param = "") => {
  const url = getAPIUrl(PlanEndpoints.deletePlan + id, param);
  return Delete(url);
};

// ✅ ASSIGN PLAN - ADD THIS
export const assignPlan = (data, param = "") => {
  const url = getAPIUrl(PlanEndpoints.assignPlan, param);
  return Post(url, data);
};

// ✅ REVOKE PLAN
export const revokePlan = (data, param = "") => {
  const url = getAPIUrl(PlanEndpoints.revokePlan, param);
  return Post(url, data);
};

// ✅ VENDOR PLAN STATUS
export const getVendorPlanStatus = (vendorId, param = "") => {
  const url = getAPIUrl(PlanEndpoints.getVendorPlanStatus + vendorId, param);
  return Get(url);
};

// ✅ ALL VENDOR PLANS
export const getAllVendorPlans = (param = "") => {
  const url = getAPIUrl(PlanEndpoints.getAllVendorPlans, param);
  return Get(url);
};